import { EmpresaService } from "../../_services/empresa.service";
import { SolrService } from "../../solr/solr.service";
import { Empresa } from "../../_models/empresa";
import { AuthenticationService } from "../../_services/authentication.service";
import { AfterViewInit, Component, OnInit, } from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, take } from "rxjs/operators";
import {MatTreeNestedDataSource} from '@angular/material/tree';
import { NestedTreeControl } from "@angular/cdk/tree";
import { ElementService } from "../../_services/element.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSliderModule} from '@angular/material/slider';
import { environment } from "../../../environments/environment";

declare const initDataRange: any;
export class MetadataFilterNode {
  name: string = "";
  children: MetadataFilterNode[] = [];
  tipo: string = "";
  selected: boolean = false;
  indeterminate: boolean = false;
  parent: MetadataFilterNode | null = null;
  solrName: string = "";
  solrCore: string = "";
  count: number = 0;
  alias: string = "";
  open: boolean = false;
  inputText: string = "";
  loaded = false;
  isEmpty: boolean = false;
  startRange: number = 1;
  endRange: number = 12;
  minValue: number = 1;
  maxValue: number = 600;
  gap: number = 1;
}

const TREE_DATA: MetadataFilterNode[] = [
];

@Component({
  standalone: true,
  selector: "app-metadata-filter",
  templateUrl: "./metadata-filter.component.html",
  styleUrls: ["./metadata-filter.component.scss"],
  imports: [CommonModule, FormsModule, MatTooltipModule, MatProgressSpinnerModule, MatSliderModule]
})
export class MetadataFilterComponent implements OnInit {
  showFilter = false;
  showFilterIndices = false;
  isLoading = false;
  filters: any = {};
  arrayFilters: any;
  empresa: Empresa | undefined;
  metadados: any;
  documents = [];
  empresaSubscription: any;
  fields: any[] = [];
  filterFields: any[] = []
  solrCore = "docs-ia";
  solrCoreSpec: string = '';
  queryFilter = "";
  prepareFinished = false;
  itemFilterName = "";
  itemCoreName = "";
  dictValuesDateRange = {};
  initDataRange: any = initDataRange;
  showFilterSubscription: any;
  searchText: string = "";
  searchTextUpdate = new Subject<any>();
  rangeUpdate = new Subject<any>();
  dictTypeFields: any = {};
  dictFieldName: any = {};
  currentNode: MetadataFilterNode = new MetadataFilterNode();
  initialState: any[] = [];
  currentNodeElement: MetadataFilterNode = new MetadataFilterNode();
  checkedFields: any = {};
  treeControl = new NestedTreeControl<MetadataFilterNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<MetadataFilterNode>();
  constructor(
    private authService: AuthenticationService,
    private solrService: SolrService,
    private empresaService: EmpresaService,
    public elementService: ElementService
  ) {
    this.dataSource.data = TREE_DATA;
  }
  hasChild = (_: number, node: MetadataFilterNode) =>  !!node.children && node.children.length > 0;

  async ngOnInit() {
    
    this.empresa = this.authService.currentUserValue.selectedEmpresa;
    const self = this;
    this.searchTextUpdate.pipe(
      debounceTime(1000))
      .subscribe((nodeObj: any) => {
        this.filterStringUpdate(nodeObj.inputText, nodeObj.solrName);
      });

    this.rangeUpdate.pipe(
      debounceTime(1000))
      .subscribe((nodeObj: any) => {
        if (nodeObj.startRange !== undefined && nodeObj.endRange!== undefined){
          this.isLoading = true;
          const mySolrCore = 'docs-ia';
          this.solrService.removeMetadataFilterQuery(nodeObj.solrName);
          this.solrService
          .getMetadataFilterByFilterQuery("fq",nodeObj.solrName, [`[${nodeObj.startRange||1} TO ${nodeObj.endRange}]`], mySolrCore, true).subscribe(solrJson =>{
            this.isLoading = false;
          })
        }
      });
      
    this.metadados = [{
      nome: "Data de Processamento",
      tipo: "Data",
      field: "last_update",
      order: -1,
      ativo: true,
      filtro: true,
      children: ['date'] 
    },
    {
      nome: "Tipo Arquivo",
      tipo: "Text",
      field: "tipo_arquivo",
      order: -1,
      ativo: true,
      filtro: true,
    }];
    
    if(this.empresa?.metadado && this.empresa?.metadados && this.empresa.metadados.length > 0) {
      if(this.empresa?.nestedMetadata) {
        this.metadados = [...this.metadados, ...(this.empresa?.nestedMetadata || [])]
      }
      this.metadados = [...this.metadados, ...(this.empresa?.metadados || [])];
      this.metadados = this.metadados.filter((m: any) => m.ativo);
      this.metadados = this.metadados.filter((m: any) => m.filtro);

      this.prepareFilter('docs-ia', true);
    } else if(this.empresa && "idMatriz" in this.empresa && this.empresa.idMatriz) {
      this.empresaService
        .getById(this.empresa?.idMatriz || '')
        .subscribe((matriz: any) => {
          if(matriz.nestedMetadata) {
            this.metadados = [...this.metadados, ...matriz.nestedMetadata]
          }
          this.metadados = [...this.metadados, ...matriz.metadados];
          this.metadados = this.metadados.filter((m: any) => m.ativo);
          this.metadados = this.metadados.filter((m: any) => m.filtro);
          
          this.prepareFilter('docs-ia', true);
        });
    } else {
      this.prepareFilter('docs-ia', true);
    }
    
    this.loadSubscriptions();
  }


  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return `${value}`;
  }
  
  GetSortOrder(prop: any) {
    return function(a: any, b: any) {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    };
  }

  async prepareFilter(solrCore: any = "docs-ia", firstCall=false) {
    //Comparer Function
    const self = this;
    this.showFilter = false;
    this.fields = [];
    this.filters = {};
    if (this.metadados.length > 0 && (this.metadados[0].order)) {
      this.metadados.sort(this.GetSortOrder("order"));
    }

    this.metadados.forEach((m: any) => {
      this.dictTypeFields[m.nome] = { name: m.field, tipo: m.tipo, order: m.order };
      this.dictFieldName[m.field] = m.nome
      this.filters[m.nome] = {
        name: m.nome,
        solrCore: solrCore,
        solrName: m.field,
        tipo: m.tipo,
        order: m.order,
        alias: m.nome,
        loaded: false,
        values: []
      };
      this.fields.push({
        name: m.field,
        alias: m.nome,
        order: m.order,
        tipo: m.tipo,
      });
    });
    this.arrayFilters = [];
    Object.keys(this.filters).forEach((key: any) => {
      if (this.filters[key].tipo==='Data'){
        this.filters[key].children = [{name:'date',tipo:'Data', children:[], solrCore: this.filters[key].solrCore, solrName: this.filters[key].solrName}];
      }
      this.arrayFilters.push(this.filters[key]);
    });
    this.arrayFilters.sort(this.GetSortOrder("order"));
    this.dataSource.data = this.arrayFilters;
    this.showFilter = true;
    this.dataSource.data.forEach((node: any) => {
      if(node.tipo === 'Data') {
        this.callDataRange(node.solrName, node.solrCore);
      }
    });
  }

 getNode(node: any) {
  node.inputText = '';
  node.checked = !node.checked;
  const keyCheck = node.name+"_"+node.parent.solrName;
  if(node.checked) {
    this.checkedFields[keyCheck] = node.name;
  }else{
    delete this.checkedFields[keyCheck];
  }
  this.currentNode = node;
  this.itemToggle(node.checked,node);
  this.applyFilter(node.parent.name, node);
 }

  applyFilter(filterKey: any, filterItem: any) {
    const modArray = this.fields.filter((data: any) => {
      return data.alias === filterKey;
    });
    // filterItem.checked = !filterItem.checked;
    if(filterItem.checked) {
      const query = this.solrService.applyFilter(
        filterKey,
        modArray[0].name,
        filterItem,
        this.filterFields,
        this.solrCore,
        this.solrCoreSpec,
        5
      );
      this.queryFilter = this.solrService.queryFilter;
      this.solrService.setCurrentQuery(query);
    } else {
      const arr = [];
      const query = this.solrService.removeFilter(
        filterKey,
        modArray[0].name,
        filterItem,
        this.fields,
        this.solrCore,
        this.solrCoreSpec
      );
      this.queryFilter = this.solrService.queryFilter;
      this.solrService.setCurrentQuery(query);
    }
  }


  removeFiterQuery(){
    let query;
    let filter: any = {filters:{}};
    for( const key of Object.keys(this.dataSource.data)){
      let metadataObj:any = this.dataSource.data[key as any];
      if (metadataObj.tipo=='Numero' && metadataObj.startRange != undefined && metadataObj.endRange != undefined){
        let field = metadataObj.solrName;
        let solrCore = metadataObj.solrCore;
        query = this.solrService.removeMetadataFilterQuery(field);
        metadataObj.startRange = undefined;
        metadataObj.endRange = undefined;
        metadataObj.open = false;
        
      }else{
        metadataObj.values.forEach((filter: any) => {
          this.filterStringUpdate("", filter.parent.solrName);
          if(filter.checked) {
            query = this.solrService.removeFilter(filter.parent.name, filter.parent.solrName, filter, this.filterFields, this.solrCore, this.solrCoreSpec);
          }
        });
      }
    };
    return query;
  }


  clearFilters() {
    this.checkedFields = []
    let query = this.solrService.lastQuery;
    query = this.removeFiterQuery() || query;
    this.solrService.clear();
    this.filterStringUpdate('', '');
    this.dictValuesDateRange = {};
    this.dataSource.data.forEach((node: any) => {
      if(node.tipo === 'Data') {
        this.callDataRange(node.solrName, node.solrCore);
      }
    });
    this.showFilter = true;
  }

  private loadSubscriptions() {
    this.empresaSubscription = this.empresaService
      .getEmpresaSelecionada()
      .subscribe((emp: Empresa) => {
        this.showFilter = false;
        this.metadados = [
          {
            nome: "Data de Processamento",
            tipo: "Data",
            field: "last_update",
            order: -1,
            ativo: true,
            filtro: true,
          },
          {
            nome: "Tipo Arquivo",
            tipo: "Text",
            field: "tipo_arquivo",
            order: -1,
            ativo: true,
            filtro: true,
          }
        ];
        this.prepareFinished = false;
        this.dataSource.data = [];
        if(emp?.nestedMetadata) {
          this.metadados = [...this.metadados, ...(emp?.nestedMetadata || [])]
        }
        if(emp?.metadado && emp?.metadados && emp.metadados.length > 0) {
          this.metadados = [...this.metadados, ...(emp?.metadados || [])];
          this.metadados = this.metadados.filter((m: any) => m.ativo);
          this.metadados = this.metadados.filter((m: any) => m.filtro);
          // adicionando o filtro de data de processamento (last_update)
          this.prepareFilter();
        } else if(emp && "idMatriz" in emp) {
          this.empresaService.getById(emp?.idMatriz || '').subscribe((matriz: any) => {
            if(emp?.nestedMetadata) {
              this.metadados = [...this.metadados, ...(emp?.nestedMetadata || [])]
            }
            this.metadados = [...this.metadados, ...(emp?.metadados || [])];
            this.metadados = this.metadados.filter((m: any) => m.ativo);
            this.metadados = this.metadados.filter((m: any) => m.filtro);
            this.prepareFilter();
          });
        } else {
          this.prepareFilter();
        }
      });
    this.showFilterSubscription = this.solrService
      .getCurrentShowFilter()
      .subscribe((value: any) => {
        this.prepareFilter();
        if(!value === false &&
          this.authService.currentUserValue?.selectedEmpresa?.metadado &&
          this.authService.currentUserValue?.selectedEmpresa?.metadados &&
          this.authService.currentUserValue.selectedEmpresa.metadados.length >
            0 &&
          this.prepareFinished) {
          Object.keys(this.filters).forEach((key: any) => {
            this.filters[key].values.forEach((filter: any) => {
              filter.checked = false;
            });
          });
          //this.showFilter = ! value;
        }
      });

  }

  applyFilterDataRange(start: any, end: any, component: any, service: any, itemName: any) {
    component.solrService.applyFilterDataRange(
      start,
      end,
      component,
      service,
      itemName
    );
  }

  callDataRange(itemName: any, itemCoreName: any) {
    this.solrService.callDataRange(itemName, itemCoreName, this);
  }

  removeDateRangeFilter() {
    this.solrService.removeDateRangeFilter(this);
  }

  async treeviwNavControl(node: any) {
    
    this.currentNodeElement = node;
    this.itemFilterName = node.solrName;
    const mySolrCore = 'docs-ia';
    let filter:any = {filters:{}};
    const filterField = this.fields.filter(f =>f.name==this.itemFilterName);
    if (filterField[0].tipo=='Numero' && !node.loaded){
      this.isLoading = true;
      let fieldName=filterField[0].name;
      this.solrService.getSolrData("Get Max Range Value", environment.solr.url,'/solr/',environment.solr.core, '/select?',`stats=true&stats.field=${fieldName}`, 'json','0',0).pipe(take(1)).subscribe((data:any) =>{
        let stats = data.stats.stats_fields[fieldName];
        if (stats.count > 0){
          node.minValue = stats.min;
          node.maxValue = stats.max;
          let lengthValue = (node.maxValue).toString().length;
          let gap = 1;
          if (lengthValue > 2){
            gap = parseInt("1"+"0".repeat(lengthValue-2));
          } 
          node.gap = gap;
          node.maxValue = node.maxValue + gap;
        }else{
          this.solrService.removeMetadataFilterQuery(fieldName);
          node.isEmpty = true;
        }
        filter.filters[this.dictFieldName[fieldName]] = {name:this.dictFieldName[fieldName],values:[], solrCore:mySolrCore};
        this.prepareMetadataFilter(filter, '', mySolrCore);
        this.isLoading = false;
      })
    }
  }
  openCloseTreeview(node: any) {
    if(node.open) {
      return 'nav-item menu-is-opening menu-open';
    }
    return 'nav-item'
  }
  
  public hideLeafNode(node: MetadataFilterNode): boolean {
    return new RegExp(this.searchText).test(node.name) === false;
  }

  public hideParentNode(node: MetadataFilterNode): boolean {
    return this.treeControl
          .getDescendants(node)
          .filter((node: any) => node.children == null || node.children.length === 0)
          .every((node: any) => this.hideLeafNode(node));
  }

  prepareMetadataFilter(metadata:any, searchString:string, mySolrCore:string, stringUpdate=false){
    for (const key of Object.keys(metadata.filters)) {
      if (!(key in this.dictTypeFields)) {
        continue;
      }
      if (metadata.filters[key].values.length > 0) {
        
        metadata.filters[key].solrName = this.dictTypeFields[key].name;
        metadata.filters[key].tipo = this.dictTypeFields[key].tipo;
        metadata.filters[key].solrCore = mySolrCore;
        metadata.filters[key].alias = key;
        metadata.filters[key].order = this.dictTypeFields[key].order;
        metadata.filters[key].children = metadata.filters[key].values;
        metadata.filters[key].isEmpty = false;
        this.filters[key] = metadata.filters[key];
      }else{
        metadata.filters[key].solrName = this.dictTypeFields[key].name;
        metadata.filters[key].tipo = this.dictTypeFields[key].tipo;
        metadata.filters[key].solrCore = mySolrCore;
        metadata.filters[key].alias = key;
        metadata.filters[key].order = this.dictTypeFields[key].order;
        metadata.filters[key].isEmpty = true;
        this.filters[key] = metadata.filters[key];
      }
    }
    if (Object.keys(this.filters).length > 0) {
      this.arrayFilters = [];
      Object.keys(this.filters).forEach((key: any) => {
        if (this.filters[key].tipo==='Data'){
          this.filters[key].children = [{name:'date',tipo:'Data', children:[], solrCore: this.filters[key].solrCore, solrName: this.filters[key].solrName}];
        }
        this.arrayFilters.push(this.filters[key]);
      });
      this.arrayFilters.sort(this.GetSortOrder("order"));
      this.dataSource.data = this.arrayFilters;
      if(searchString.length > 0) {
        Object.keys(this.dataSource.data).forEach((key: any) => {
          this.setParent(this.dataSource.data[key], new MetadataFilterNode());
          if (this.dataSource.data[key].solrName === this.currentNodeElement.solrName){
            this.dataSource.data[key].open = true;
            this.dataSource.data[key].inputText = this.currentNodeElement.inputText;
          }else{
            this.dataSource.data[key].inputText = "";
          }
        }); 
      }else if(stringUpdate){
        Object.keys(this.dataSource.data).forEach((key: any) => {
          this.setParent(this.dataSource.data[key], new MetadataFilterNode());
          (this.dataSource.data[key] as any).values.forEach((filter: any) => {
            filter.checked = false;
            filter.selected = false;
          });
        });
      }else{
        Object.keys(this.dataSource.data).forEach((key: any) => {
          this.setParent(this.dataSource.data[key], new MetadataFilterNode());
          (this.dataSource.data[key] as any).values.forEach((filter: any) => {
            if(filter.name+"_"+filter.parent.solrName in this.checkedFields) {
              this.dataSource.data[key].open = true;
              this.dataSource.data[key].inputText = this.currentNodeElement.inputText;
              this.dataSource.data[key].startRange = this.currentNodeElement.startRange;
              this.dataSource.data[key].endRange = this.currentNodeElement.endRange;
              this.dataSource.data[key].minValue = this.currentNodeElement.minValue;
              this.dataSource.data[key].maxValue = this.currentNodeElement.maxValue;
              this.dataSource.data[key].gap = this.currentNodeElement.gap;
              filter.checked = true;
              filter.selected = true;
            }
          });
          if (this.dataSource.data[key].solrName === this.currentNodeElement.solrName){
            this.dataSource.data[key].open = true;
            this.dataSource.data[key].loaded = true;
            this.dataSource.data[key].inputText = this.currentNodeElement.inputText;
            this.dataSource.data[key].startRange = this.currentNodeElement.startRange;
            this.dataSource.data[key].endRange = this.currentNodeElement.endRange;
            this.dataSource.data[key].minValue = this.currentNodeElement.minValue;
            this.dataSource.data[key].maxValue = this.currentNodeElement.maxValue
            this.dataSource.data[key].gap = this.currentNodeElement.gap;
          }else{
            this.dataSource.data[key].inputText = "";
            this.dataSource.data[key].startRange = this.currentNodeElement.startRange;
            this.dataSource.data[key].gap = this.currentNodeElement.gap;
          }
        }); 
      }
    }
  }

  convertSolrJsonToFilter(solrJson:any, field:string, mySolrCore: string){
    const filter: any = {filters:{}};
    let list = solrJson['response']['docs'].map((doc:any) => doc[field]);
    if (field.indexOf("nested_metadata_"+this.empresa!.nestedMetadataKey)!=-1){
      list = solrJson['response']['docs'].map((doc:any) => doc["nested_metadata_"+this.empresa!.nestedMetadataKey][0][field]);
    }
    const uniqueValues = [...new Set(list)];
    filter.filters[this.dictFieldName[field]] = {name:this.dictFieldName[field],values:[], solrCore:mySolrCore};
    for (const value of uniqueValues){
      filter.filters[this.dictFieldName[field]].values.push({name:value,"checked":false, tipos:[]});
    }
    return filter
  }

  public filterStringUpdate(searchString: string, field: string) {
    const self = this;
    const mySolrCore = 'docs-ia';
    let filter: any = {filters:{}};
    if(searchString.length == 0) {
      this.isLoading = true;
      if (field){

        this.solrService.removeMetadataFilterQuery(field);
        filter.filters[this.dictFieldName[field]] = {name:this.dictFieldName[field],values:[], solrCore:mySolrCore};
      }
      this.prepareMetadataFilter(filter, "", mySolrCore, true);
      this.isLoading = false;
    }
    if(searchString && searchString.length > 2) {
      this.isLoading = true;
      this.solrService
        .getMetadataFilterByFilterQuery("fq", field,[searchString+"*"], mySolrCore, false, field.indexOf("nested_metadata_"+this.empresa!.nestedMetadataKey)==-1)
        .subscribe((solrJson: any) => {
          filter = this.convertSolrJsonToFilter(solrJson, field, mySolrCore);
          this.prepareMetadataFilter(filter, searchString, mySolrCore, true);
          this.isLoading = false;
        });
    }
  }

  private setParent(node: MetadataFilterNode, parent: MetadataFilterNode) {
    node.parent = parent;
    if(node.children) {
      node.children.forEach((childNode: any) => {
        this.setParent(childNode, node);
      });
    }
  }

  private checkAllParents(node: MetadataFilterNode) {
    if(node.parent) {
      const descendants = this.treeControl.getDescendants(node.parent);
      node.parent.selected = descendants.every((child: any) => child.selected);
      node.parent.indeterminate = descendants.some((child: any) => child.selected);
      this.checkAllParents(node.parent);
    }
  }

  private itemToggle(checked: boolean, node: MetadataFilterNode) {
    node.selected = checked;
    if(node.children) {
      node.children.forEach((child: any) => {
        this.itemToggle(checked, child);
      });
    }
    this.checkAllParents(node);
  }


  ngOnDestroy(): void {
    if(this.empresaSubscription) {
      this.empresaSubscription.unsubscribe();
    }
    if(this.showFilterSubscription) {
      this.showFilterSubscription.unsubscribe();
    }
  }
}
